// src/lib/environment.ts

export type AppEnvironment =
  | "dev"
  | "staging"
  | "prod";

/* -------------------------------------------------------------------------- */
/* Helpers                                                                    */
/* -------------------------------------------------------------------------- */

function requiredEnv(
  value:
    string | undefined,

  name:
    string,
): string {
  const normalizedValue =
    value
      ?.trim();

  if (
    !normalizedValue
  ) {
    throw new Error(
      `${name} is not configured`,
    );
  }

  return normalizedValue;
}

function optionalUrl(
  value:
    string | undefined,
): string | undefined {
  const normalizedValue =
    value
      ?.trim()
      .replace(
        /\/+$/,
        "",
      );

  return normalizedValue ||
    undefined;
}

/* -------------------------------------------------------------------------- */
/* Environment                                                                */
/* -------------------------------------------------------------------------- */

export const APP_ENV:
AppEnvironment =
  import.meta.env.VITE_APP_ENV;

export const APP_BASE_URL =
  requiredEnv(
    import.meta.env.VITE_APP_BASE_URL,
    "VITE_APP_BASE_URL",
  )
    .replace(
      /\/+$/,
      "",
    );

export const ACCESS_REQUEST_API_BASE_URL =
  optionalUrl(
    import.meta.env
      .VITE_ACCESS_REQUEST_API_BASE_URL,
  );

export const LOGIN_URL =
  `${APP_BASE_URL}/login`;